import './home/banner'
import './home/cotizador'
import './home/galeria'
import './about'
import './forms'


import { useGlightbox } from "~/lib/glightbox"

useGlightbox('.glightbox')